import { tournamentPath } from "./tournamentUrls";

/**
 * Tournament page URLs that used to live under Admin.
 */

const FINANCE_TABS = {
  "payout-table": "payout-table",
  payouts: "payouts",
  "added-money": "added-money",
  "prize-fund": "added-money",
  financial: "added-money",
  prizes: "prizes",
};

export const getSetupUrl = (tournamentId) =>
  tournamentPath(tournamentId, "/setup");

export const getSettingsUrl = (tournamentId) =>
  tournamentPath(tournamentId, "/settings");

export const getFinanceUrl = (tournamentId, tabName = "payouts") => {
  const tab = FINANCE_TABS[tabName] || "payouts";
  return tournamentPath(tournamentId, `/finance/${tab}`);
};

export const getScoringUrl = (tournamentId, tabName = "scores", search = "") => {
  const tab = tabName === "lanes" ? "lanes" : "scores";
  const path = tournamentPath(tournamentId, `/scoring/${tab}`);
  const query =
    typeof search === "string"
      ? search.replace(/^\?/, "")
      : search?.toString?.() || "";
  return query ? `${path}?${query}` : path;
};

export const getBracketsUrl = (tournamentId, search = "") => {
  const path = tournamentPath(tournamentId, "/brackets");
  const query =
    typeof search === "string"
      ? search.replace(/^\?/, "")
      : search?.toString?.() || "";
  return query ? `${path}?${query}` : path;
};

export const scoringToBracketsHref = (tournamentId, squadId) => {
  if (squadId && squadId !== "all" && !String(squadId).startsWith("date:")) {
    return getBracketsUrl(tournamentId, `squad=${squadId}`);
  }
  return getBracketsUrl(tournamentId);
};

/**
 * @param {string} tournamentId
 * @param {string} tabName - setup, squads, financial, settings
 */
export const getAdminTabUrl = (tournamentId, tabName) => {
  if (tabName === "financial") {
    return getFinanceUrl(tournamentId, "added-money");
  }
  if (tabName === "settings") {
    return getSettingsUrl(tournamentId);
  }
  return getSetupUrl(tournamentId);
};

export const getTabDisplayName = (tabName) => {
  const tabNames = {
    setup: "Setup",
    financial: "Payouts",
    settings: "Settings",
    "payout-table": "Payout table",
    payouts: "Payouts",
    "added-money": "Added money",
    "prize-fund": "Added money",
    prizes: "Prizes",
  };

  return tabNames[tabName] || tabName;
};

export const getAdminTabs = () => {
  return [
    {
      id: "setup",
      name: "Setup",
      description: "Events, squads, signups, and documents",
      icon: "FaFileAlt",
    },
    {
      id: "financial",
      name: "Payouts",
      description: "Payouts, added money, payout table, and prizes",
      icon: "FaDollarSign",
    },
    {
      id: "settings",
      name: "Settings",
      description: "Tournament details, QR codes, and delete",
      icon: "FaCog",
    },
  ];
};
